import React from 'react';
import { Redirect, useRouteMatch } from 'react-router-dom';

import { useExternalAccessRights } from 'common/hooks';
import { usePermissions } from 'common/wolt-permissions';
import * as permissionUtils from 'common/wolt-permissions/permissionUtils';
import NotFound from 'core/NotFound';

import { useVenueContext } from '../VenueContext';

type VenueRouteParams = {
  feature: 'venue';
  slug: string;
};

const VenueRoot = () => {
  const permissions = usePermissions();
  const externalAccessRights = useExternalAccessRights();
  const { params } = useRouteMatch<VenueRouteParams>();
  const venue = useVenueContext();

  if (venue.type !== 'daas' && permissionUtils.hasVenueInsightsPermission(permissions, externalAccessRights, venue)) {
    return <Redirect to={`/venue/${params.slug}/insights`} />;
  }
  if (venue.type !== 'daas' && permissionUtils.hasMenuEditorPermission(permissions, externalAccessRights, venue)) {
    return <Redirect to={`/venue/${params.slug}/menu-editor`} />;
  }
  if (permissionUtils.hasVenueDetailsViewPermission(permissions, externalAccessRights, venue)) {
    return <Redirect to={`/venue/${params.slug}/details`} />;
  }
  if (venue.type !== 'daas' && permissionUtils.hasTranslationPermission(permissions, externalAccessRights, venue)) {
    return <Redirect to={`/venue/${params.slug}/translation`} />;
  }
  return <NotFound />;
};

export default VenueRoot;
